<template lang="pug">
AppPopover(
  trigger="hover"
  lazy
)
  template(slot="body")
    h6.m-0 Time is locked
    ul.list-unstyled.mt-15(v-if="reasons.length")
      li(
        v-for="(reason, index) in reasons"
        :key="index"
      )
        i.hi.hi-check-circle-filled.hi-16
        span.ml-5 {{ status(reason) }}
  template(slot="trigger")
    .no-action.label.label-default.text-white
      i.hi.hi-lock.hi-12
      |
      | Locked
</template>

<script>
const REASONS = {
  team_payments: 'Paid',
  invoices: 'Invoiced',
  user_invoices: 'User invoiced',
  timesheet: 'Approved',
  integrations: `Sync'ed`,
};

export default {
  name: 'ActivitiesLockedPopover',
  props: {
    associatedRecords: {
      type: Array,
      required: true,
    },
  },
  computed: {
    reasons() {
      return this.associatedRecords.filter((key) => key in REASONS);
    },
  },
  methods: {
    status(key) {
      return REASONS[key];
    },
  },
};
</script>
